import { withInstall } from '@sgui-plus/utils/with-install'

import Alert from './src/alert.vue'

export const SgAlert = withInstall(Alert)
export default SgAlert

export * from './src/alert'
